import { FormEvent, useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'

import SimpleDate from 'app/common/classes/simple-date'
import usePopupErr from 'app/common/hooks/usePopupErr'
import type { SurveyFilters, SurveyScope } from 'app/common/types/surveys'
import { useCreateSurvey } from 'app/dataProviders/surveys/hooks'

import { emptySurveyFilters } from '../filters'

export const useCreateSurveyState = () => {
  const history = useHistory()
  const [popupErr] = usePopupErr()
  const [title, setTitle] = useState('')
  const [filters, setFilters] = useState<SurveyFilters>(() => {
    const today = SimpleDate.createToday()

    return {
      ...emptySurveyFilters,
      from: today,
      to: today.duplicate(30),
    }
  })
  const { pending, submit } = useCreateSurvey({
    onSuccess: createdSurvey => history.push(`/surveys/${createdSurvey.id}`),
  })

  const handleSubmit = useCallback(
    async (event: FormEvent<HTMLFormElement>) => {
      if (event.target !== event.currentTarget) return

      event.preventDefault()
      if (pending) return
      if (!title.trim()) {
        popupErr('Введите наименование опроса')
        return
      }

      const { from, to } = filters
      if (!from?.isValid() || !to?.isValid() || !to.isSameOrAfter(from)) {
        popupErr('Дата окончания не должна быть раньше даты начала')
        return
      }

      const scope: SurveyScope = {
        cityIds: filters.cityIds,
        districtIds: filters.cityIds.length === 1 ? filters.districtIds : [],
        schoolType: filters.schoolTypes[0],
        schoolIds: filters.cityIds.length === 1 ? filters.schoolIds : [],
      }

      await submit({
        title,
        startsOn: from,
        endsOn: to,
        scope,
      })
    },
    [filters, pending, popupErr, submit, title],
  )

  return {
    title,
    setTitle,
    filters,
    setFilters,
    pending,
    handleSubmit,
  }
}
